<template>
  <div id="GuestCheckIn_main">
    <!-- 即將抵達訪客列表 訪客登記區塊 -->
    <p class="title">
      訪客登記
    </p>
    <div class="checkInWrap">
      <el-table
        v-loading="loading"
        :data="data"
        :header-cell-class-name="cellStyle"
      >
        <el-table-column label="訪客事由">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.cause"
              :class="!formRule.cause ? 'redBorder' : ''"
              @change="checkFormRule('訪客事由')"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="拜訪戶別">
          <template slot-scope="scope">
            <el-button
              v-if="!householdSwitch && !householdValue"
              round
              @click="householdSwitch=true"
            >
              {{ scope.row.tabletId && householdValue || $t('Household.SelectHousehold') }}
            </el-button>
            <div v-else>
              <p>{{ householdValue }}</p>
              <span
                class="householdSwitch"
                @click="householdSwitch=true"
              >重新選擇</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="訪客／廠商名稱"
          min-width="100"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.tableGuestName.inputValue"
              :class="!formRule.guestName ? 'redBorder' : ''"
              maxlength="20"
              placeholder="請輸入"
              :clearable="true"
              :disabled="scope.row.tableGuestName.listValue !== '請選擇'"
              @input="checkFormRule('訪客名稱')"
            />
            <el-select
              v-model="scope.row.tableGuestName.listValue"
              :class="!formRule.guestName ? 'redBorder' : ''"
              class="checkInNameSelect"
              no-data-text="無廠商"
              :disabled="scope.row.tableGuestName.inputValue !== ''"
              @change="checkFormRule('訪客名稱')"
            >
              <el-option
                v-for="item in vendorOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="電話號碼">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.cellPhone"
              placeholder="請輸入"
              maxlength="10"
              class="inputNumber"
              :clearable="true"
              :class="!formRule.cellPhone ? 'redBorder' : ''"
              @input="checkFormRule('電話號碼')"
            />
          </template>
        </el-table-column>
        <el-table-column :label="$t('Guest.LicensePlateNumber')">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.licensePlateNumber"
              :placeholder="$t('Guest.PleaseEnter')"
              maxlength="8"
              :clearable="true"
              @input="checkFormRule($t('Guest.LicensePlateNumber'))"
            />
          </template>
        </el-table-column>
        <el-table-column :label="$t('Guest.Remark')">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.remark"
              maxlength="30"
              :clearable="true"
              :placeholder="$t('Guest.PleaseEnter')"
            />
          </template>
        </el-table-column>
      </el-table>
      <div class="checkInButton">
        <el-button
          type="primary"
          class="checkIn"
          size="medium"
          round
          @click="registerGuestRule"
        >
          登記
        </el-button>
      </div>
    </div>
    <GuestArriveDialog
      ref="GuestArriveDialog"
      :qrcode-enable-web="qrcodeEnable.web"
      @guestCheckInInit="init"
    />
    <HouseholdFrame
      :open.sync="householdSwitch"
      @select-household="selectedHousehold"
    />
  </div>
</template>
<script>
import HouseholdFrame from '@/components/HouseholdFrame'
import GuestArriveDialog from '../components/GuestArriveDialog'
import { isValidCellphone, isValidCellphoneNotContainZero } from '@/js/utils/unitValidate'
import { formatLicensePlateNumber } from '@/js/utils/guest'

export default {
  components: {
    HouseholdFrame,
    GuestArriveDialog
  },
  props: {
    guestCauseList: Array,
    qrcodeEnable: Object
  },
  data () {
    return {
      data: [
        {
          guestName: '',
          cause: 0,
          tabletId: '',
          cellPhone: '',
          licensePlateNumber: '',
          remark: '',
          tableGuestName: {
            inputValue: '',
            listValue: '請選擇'
          }
        }
      ],
      options: [
        {
          value: 0,
          label: '請選擇'
        }
      ],
      vendorOptions: [
        {
          value: '請選擇',
          label: '請選擇'
        }
      ],
      formRule: { // 確認登記表單格式
        cause: true,
        guestName: true,
        cellPhone: true
      },
      loading: false,
      causeLoading: true,
      householdSwitch: false,
      householdValue: ''
    }
  },
  watch: {
    guestCauseList () {
      this.options = [
        {
          value: 0,
          label: '請選擇'
        }
      ]
      this.data[0].cause = 0
      this.guestCauseList.forEach(item => {
        this.options.push(
          {
            value: item.Id,
            label: item.Name
          }
        )
      })
      this.loading = false
    }
  },
  methods: {
    // 欄位輸入限制
    checkFormRule (item) {
      if (item === '訪客事由') {
        this.formRule.cause = this.data[0].cause !== 0
        if (this.data[0].cause !== 0) { this.getVendorOptions() }
      } else if (item === '訪客名稱') {
        const guestNameRule = this.data[0].tableGuestName.inputValue !== ''
        const guestListValueRule = this.data[0].tableGuestName.listValue !== '請選擇'
        this.formRule.guestName = !((!guestNameRule && !guestListValueRule))
      } else if (item === '電話號碼') {
        // 限制只能輸入數字(若在 onkeyup 修改會造成輸入中文後 v-model 無法綁定值回來)
        this.data[0].cellPhone = this.data[0].cellPhone.replace(/[^\d]/g, '')

        if (isValidCellphone(this.data[0].cellPhone)) {
          this.formRule.cellPhone = true
        } else if (isValidCellphoneNotContainZero(this.data[0].cellPhone)) {
          this.data[0].cellPhone = `0${this.data[0].cellPhone}` // 開頭未輸入0,自動補0
          this.formRule.cellPhone = true
        } else if (this.data[0].cellPhone === '') { // 因為非必填
          this.formRule.cellPhone = true
        } else {
          this.formRule.cellPhone = false
        }
      } else if (item === '車牌') {
        // 格式化車牌號碼
        this.data[0].licensePlateNumber = formatLicensePlateNumber(this.data[0].licensePlateNumber)
      }
    },
    getVendorOptions () {
      this.data[0].tableGuestName.listValue = '請選擇'
      const index = this.data[0].cause
      this.guestCauseList.forEach(item => {
        if (item.Id === index) {
          if (item.VendorTypes.length !== 0) {
            this.vendorOptions = [{
              value: '請選擇',
              label: '請選擇'
            }]
            this.data[0].tableGuestName.listValue = '請選擇'
            item.VendorTypes.forEach(vendor => {
              this.vendorOptions.push({
                value: vendor.Name,
                label: vendor.Name
              })
            })
          } else {
            this.vendorOptions = []
          }
        }
      })
    },
    // 登記button 確認登記訪客格式正確
    registerGuestRule () {
      let errtxt1 = ''
      let errtxt2 = ''
      this.data[0].guestName = this.data[0].tableGuestName.inputValue !== '' ? this.data[0].tableGuestName.inputValue : this.data[0].tableGuestName.listValue
      this.data[0].guestName = this.data[0].guestName === '請選擇' ? '' : this.data[0].guestName // 請選擇算是空值
      console.log(this.data[0].guestName)
      if (this.data[0].cause === 0 || this.data[0].tabletId === '' || this.data[0].guestName === '' && this.formRule.cellPhone) { errtxt1 = '請填寫「訪客事由」與「拜訪戶別」與「訪客／廠商名稱」' }
      if (this.data[0].guestName && this.data[0].guestName.length < 2) { errtxt1 = '<p>訪客／廠商名稱請輸入最少為 2 個字</p>' }
      if (!this.formRule.cellPhone) { errtxt2 = '電話號碼格式錯誤' }
      if (errtxt1 === '' && errtxt2 === '') {
        this.registerGuest()
      } else {
        this.$alert(`<p>${errtxt1}</p><p>${errtxt2}</p>`, '錯誤', {
          type: 'error',
          dangerouslyUseHTMLString: true,
          callback: action => {}
        })
      }
    },
    // 登記訪客
    registerGuest () {
      console.log(this.data[0].tableGuestName)
      console.log(this.data[0].tableGuestName)
      this.$refs.GuestArriveDialog.guestCreateAndArrived(this.data[0]) // 開啟押件和門禁卡彈窗
    },
    init () {
      console.log('init()')
      this.data[0].guestName = ''
      this.data[0].cause = 0
      this.data[0].tabletId = ''
      this.data[0].cellPhone = ''
      this.data[0].licensePlateNumber = ''
      this.data[0].remark = ''
      this.data[0].tableGuestName.inputValue = ''
      this.data[0].tableGuestName.listValue = '請選擇'
      this.householdValue = ''
    },
    selectedHousehold (content) { // 已選擇戶別
      console.log(content)
      this.data[0].tabletId = content.TabletId
      this.householdValue = content.TabletNote
      this.householdSwitch = false
    },
    // table 樣式
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) { return 'redStart' }
    }
  }
}
</script>
<style lang="sass" scoped>
#GuestCheckIn_main
  color: $subFontColor
  .title
    color: $mainFontColor
    text-align: left
    font-size: 15px
    font-weight: bold
    line-height: 50px
  .checkInWrap
    border-radius: 4px
    border: 1px $borderDark1 solid
    ::v-deep .el-table
      +basicTable
      border-top-right-radius: 4px
      border-top-left-radius: 4px
      th
        background-color: $borderDark3
        height: 50px
        border-bottom: 0
        .cell
          position: relative
          left: 10px
        &.redStart
          .cell
            &::before
              position: absolute
              top: 0
              left: 0px
              content: "*"
              color: $dangerColor
      .el-table__body
        td
          position: relative
          height: 117px
          width: 100%
          .cell
            position: absolute
            top: 12px
            width: 95%
        .el-table__row
          position: relative
          left: 10px
          .el-select
            width: 100%
          .householdSwitch
            line-height: 35px
            cursor: pointer
            color: $mainColor
            border-bottom: 1px $mainColor solid
        tr:hover,tr.hover-row
          > td
            background-color: $white
            &:first-child
              border-left: 0px
      .redBorder
        .el-input__inner
          border: $dangerColorHover 1px solid
      .checkInNameSelect
        margin-top: 12px
        width: 100%
      .el-input
        &.inputNumber
          .el-input__inner
            line-height: 1px
          input::-webkit-outer-spin-button,input::-webkit-inner-spin-button
            -webkit-appearance: none
            margin: 0
    .checkInButton
      text-align: center
      .checkIn
        margin: 17px 0
</style>
